"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Draggable = require("../DragAndDrop/Draggable");
var _constants = require("./constants");
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/NestableListBase/withDNDContext.js";
var _default = Component => props => /*#__PURE__*/_react.default.createElement("div", {
  "data-hook": props.dataHook,
  __self: void 0,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 8,
    columnNumber: 5
  }
}, /*#__PURE__*/_react.default.createElement(_Draggable.Draggable.Manager, {
  dataHook: _constants.dataHooks.provider,
  __self: void 0,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9,
    columnNumber: 7
  }
}, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
  __self: void 0,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 10,
    columnNumber: 9
  }
}))));
exports.default = _default;
//# sourceMappingURL=withDNDContext.js.map